import { createVehicleVerification, getVehicleVerificationMetrics } from '../api/requests'
import useModal from './modalHook'
import CreateVerification from '../views/shared/vehicle-verification/CreateVerification'
import { useQueryClient } from '@tanstack/react-query'
import { VerifiedVehicle } from '../models/verifiedVehicle/VerifiedVehicle'
import useUserAccount from './userAccountHook'
import { showToast } from '../utils/miscFunctions'



function useVehicleVerification() {
    const { updateModalStates, ModalComponent, closeModal, } = useModal()
    const {user} =useUserAccount()
    const VeificationModal = ModalComponent
    const invalidateQueries = useQueryClient()
    
    const handleInspectionCreation = async(payload: any, onProceed: () => void) => {
        try {
            const response: any = await createVehicleVerification(payload)
            if (response) {
                showToast.success(response?.message ?? 'Vehicle verification created successfully', );
                onProceed()
            }
        } catch (error) {
            console.log(error)
        }
    };

    const fetchVehicleVerifiactionMetrics = async ( companyId?: string, startDate?: string, endDate?: string) => {
        try {
            const response: any = await getVehicleVerificationMetrics(user.isInternalAdmin() ? Number(companyId) : undefined, startDate, endDate)
            return response
        } catch (error) {
            console.log(error)
        }
    }

    const handleAddVehicleVerification = () => {
        updateModalStates({
            show: true,
            size: '3xl',
            children: (
                <CreateVerification
                    type="vehicle"
                    onProceed={() => {
                        closeModal()
                       // invalidateQueries.invalidateQueries({ queryKey: ['fetchAllVehicleVerifications'] })
                   
                    }}
                    onClose={closeModal}
                />
            ),
            title: 'Single Inspection',
            static: false,
        });
    };

    const showFleetVehicleVerificationUploadModal = () => {
        updateModalStates({
            show: true,
            size: '3xl',
            children: (
                <CreateVerification
                    type="fleet"
                    onProceed={() => {
                        closeModal()
                        invalidateQueries.invalidateQueries({ queryKey: ['fetchAllVehicleVerifications'] })
                    }}
                    onClose={closeModal}
                />
            ),
            static: false,
        });
    };

    const hadnleEditVehicleVerification = (vehicleInfo: VerifiedVehicle) => {
        vehicleInfo &&
            updateModalStates({
                show: true,
                size: '3xl',
                children: (
                    <CreateVerification
                        onProceed={() => {
                            closeModal()
                            invalidateQueries.invalidateQueries({ queryKey: ['fetchAllVehicleVerifications'] })
                        }}
                        onClose={closeModal}
                        vehicleInfo={vehicleInfo}
                        isEdit={true}
                    />
                ),
                static: true,
            });
    }

    return {
        fetchVehicleVerifiactionMetrics,
        VeificationModal,
        handleAddVehicleVerification,
        showFleetVehicleVerificationUploadModal,
        hadnleEditVehicleVerification,
        handleInspectionCreation
    }
}

export default useVehicleVerification